import ApiInstance from './instance'
import { IEligibilityTaskFiltersDTO, IPatientLiability } from '@zunta/configurations'

export default class EligibilityTaskApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  getTasksByFilters (filters: IEligibilityTaskFiltersDTO) {
    return this.instance.doGet('/eligibilityTasks', filters)
  }

  assignUserToTask (userId: number, taskId: number) {
    return this.instance.doPut(`/eligibilityTasks/${taskId}/assign`, { userId })
  }

  submitPatientLiability (taskId: number, data: IPatientLiability[], noPatientLiabilityData: boolean | null) {
    return this.instance.doPost(`/eligibilityTasks/${taskId}/submitPatientLiability`, { data, noPatientLiabilityData })
  }

  updateTask (taskId: number, data: Partial<any>) {
    return this.instance.doPut(`/eligibilityTasks/${taskId}`, data)
  }

  countPendingTasks () {
    return this.instance.doGet('/eligibilityTasks/countPendingTasks')
  }
}
